import walesSvg from "../assets/Images/wales.svg";
import southEastSvg from "../assets/Images/south-east.svg";
import eastOfEnglandSvg from "../assets/Images/east-england.svg";
import yorkshireSvg from "../assets/Images/yorkshire.svg";
import eastMidlandsSvg from "../assets/Images/east-midlands.svg";
import westMidlandsSvg from "../assets/Images/west-midlands.svg";
import londonAreaSvg from "../assets/Images/london-area.svg";
import southWestSvg from "../assets/Images/south-west.svg";
import northWestSvg from "../assets/Images/north-west.svg";
import scotlandSvg from "../assets/Images/scotland.svg";
import northIrelandSvg from "../assets/Images/north-ireland.svg";

const MapData = [
	{
		title: "Wales",
		subTitle: "Change",
		text: "Construction Investment",
		id: "wales",
		image: walesSvg,
		width: 170,
		height: 6,
		listTable: [
			{
				date: "2015/16",
				info: "£456,987,707",
			},
			{
				date: "2020/21",
				info: "£573,752,444",
			},
			{
				percentage: "26%",
			},
		],
	},
	{
		title: "South East",
		subTitle: "Change",
		text: "Construction Investment",
		id: "south-east",
		image: southEastSvg,
		width: 134,
		height: 54,
		listTable: [
			{
				date: "2015/16",
				info: "£709,288,784",
			},
			{
				date: "2020/21",
				info: "£854,845,956",
			},
			{
				percentage: "21%",
			},
		],
	},
	{
		title: "East of England",
		subTitle: "Change",
		text: "Construction Investment",
		id: "east-england",
		image: eastOfEnglandSvg,
		width: 39,
		height: 6,
		listTable: [
			{
				date: "2015/16",
				info: "£404,135,302",
			},
			{
				date: "2020/21",
				info: "£487,064,847",
			},
			{
				percentage: "21%",
			},
		],
	},
	{
		title: "Yorkshire and Humber",
		subTitle: "Change",
		text: "Construction Investment",
		id: "yorkshire",
		image: yorkshireSvg,
		width: 118,
		height: 79,
		listTable: [
			{
				date: "2015/16",
				info: "£917,366,313",
			},
			{
				date: "2020/21",
				info: "£991,049,564",
			},
			{
				percentage: "8%",
			},
		],
	},
	{
		title: "East Midlands",
		subTitle: "Change",
		text: "Construction Investment",
		id: "east-midlands",
		image: eastMidlandsSvg,
		width: 118,
		height: 79,
		listTable: [
			{
				date: "2015/16",
				info: "£139,499,212",
			},
			{
				date: "2020/21",
				info: "£136,933,632",
			},
			{
				percentage: "-2%",
			},
		],
	},
	{
		title: "West Midlands",
		subTitle: "Change",
		text: "Construction Investment",
		id: "west-midlands",
		image: westMidlandsSvg,
		width: 249,
		height: 51,
		listTable: [
			{
				date: "2015/16",
				info: "£425,040,859",
			},
			{
				date: "2020/21",
				info: "£411,730,556",
			},
			{
				percentage: "-3%",
			},
		],
	},
	{
		title: "London",
		subTitle: "Change",
		text: "Construction Investment",
		id: "london",
		image: londonAreaSvg,
		width: 85,
		height: 5,
		listTable: [
			{
				date: "2015/16",
				info: "£395,912,175",
			},
			{
				date: "2020/21",
				info: "£344,010,140",
			},
			{
				percentage: "-13%",
			},
		],
	},
	{
		title: "South West",
		subTitle: "Change",
		text: "Construction Investment",
		id: "south-west",
		image: southWestSvg,
		width: 268,
		height: 6,
		listTable: [
			{
				date: "2015/16",
				info: "£247,070,160",
			},
			{
				date: "2020/21",
				info: "£214,135,859",
			},
			{
				percentage: "-13%",
			},
		],
	},
	{
		title: "North East",
		subTitle: "Change",
		text: "Construction Investment",
		id: "north-east",
		image: northWestSvg,
		width: 164,
		height: 81,
		listTable: [
			{
				date: "2015/16",
				info: "£70,970,217",
			},
			{
				date: "2020/21",
				info: "£61,366,869",
			},
			{
				percentage: "-14%",
			},
		],
	},
	{
		title: "North West",
		subTitle: "Change",
		text: "Construction Investment",
		id: "north-west",
		image: westMidlandsSvg,
		width: 280,
		height: 51,
		listTable: [
			{
				date: "2015/16",
				info: "£277,818,116",
			},
			{
				date: "2020/21",
				info: "£238,688,957",
			},
			{
				percentage: "-14%",
			},
		],
	},
	{
		title: "Scotland",
		subTitle: "Change",
		text: "Construction Investment",
		id: "scotland",
		image: scotlandSvg,
		width: 286,
		height: 3,
		listTable: [
			{
				date: "2015/16",
				info: "£531,337,228",
			},
			{
				date: "2020/21",
				info: "£423,801,205",
			},
			{
				percentage: "-20%",
			},
		],
	},
	{
		title: "Northern Ireland",
		subTitle: "Change",
		text: "Construction Investment",
		id: "northern-ireland",
		image: northIrelandSvg,
		width: 90,
		height: 90,
		listTable: [
			{
				date: "2015/16",
				info: "£58,044,537",
			},
			{
				date: "2020/21",
				info: "£31,788,073",
			},
			{
				percentage: "-45%",
			},
		],
	},
];

export default MapData;
